import { Box, Typography, Grid } from "@mui/material";
import { PersonRecord } from "../../types";

const PersonEntityHeader = ({ person }: { person: PersonRecord }) => {
  if (!person) return null;

  const fullName = [person.title, person.firstName, person.middleName, person.lastName, person.suffix]
    .filter(Boolean)
    .join(" ");

  return (
    <Box sx={{ p: 1, bgcolor: "#f5f5f5", borderRadius: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0.5 }}>
        Blacklist Details
      </Typography>

      <Grid container spacing={0.25}>
        <Grid item xs={12}>
          <Typography variant="body2">
            <strong>Blacklist Type:</strong> Individual
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="body2">
            <strong>Name:</strong> {fullName}
          </Typography>
        </Grid>

        {person.taxID && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Tax ID:</strong> {person.taxID}
            </Typography>
          </Grid>
        )}

        {person.isAttorney && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Attorney:</strong> Yes
              {person.yearAdmittedToBar ? ` (Bar: ${person.yearAdmittedToBar})` : ""}
            </Typography>
          </Grid>
        )}

        {person.isNotary && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Notary:</strong> Yes
            </Typography>
          </Grid>
        )}

        {person.bulletins && person.bulletins.length > 0 && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Bulletins:</strong> {person.bulletins.length}
            </Typography>
          </Grid>
        )}

        {person.createdDate && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Created:</strong> {new Date(person.createdDate).toLocaleDateString()}
            </Typography>
          </Grid>
        )}

        {person.createdByUser && (
          <Grid item xs={6}>
            <Typography variant="body2">
              <strong>Created By:</strong> {person.createdByUser.fullName}
            </Typography>
          </Grid>
        )}
      </Grid>

      {person.notes && (
        <Box sx={{ mt: 0.25 }}>
          <Typography variant="body2">
            <strong>Notes:</strong> {person.notes}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PersonEntityHeader;
